const trapFocusHandlers = {};
const focusable_elements = [
    "summary",
    "a[href]",
    "button:enabled",
    ".popup-modal__content-info",
    "[tabindex]:not([tabindex^=" - "])",
    "[draggable]",
    "area",
    "input:not([type=hidden]):enabled",
    "select:enabled",
    "textarea:enabled",
    "object",
    "iframe",
].join(",");

function getFocusableElements(container) {
    return Array.from(container.querySelectorAll(focusable_elements));
}

function fetchSectionHTML(
    sectionId,
    useCache = false,
    path = window.location.pathname
) {
    const cacheKey = `${path}::${sectionId}`;

    if (typeof this.fetched === "undefined") this.fetched = {};

    if (useCache && this.fetched[cacheKey])
        return new Promise((resolve, reject) => {
            resolve(this.fetched[cacheKey]);
        });
    else {
        return fetch(
            path +
                (path.indexOf("?") === -1 ? "?" : "&") +
                `section_id=${sectionId}`
        )
            .then((result) => {
                if (result.ok) return result.text();
                else throw new Error(result.status);
            })
            .then((html) => {
                const innerHTML = new DOMParser()
                    .parseFromString(html, "text/html")
                    .querySelector(".shopify-section").innerHTML;

                if (useCache) this.fetched[cacheKey] = innerHTML;

                return innerHTML;
            });
    }
}

function fetchLoaderHTML() {
    return Promise.all([
        document.getElementById("template-loading-overlay")?.innerHTML,
    ]).then((results) => results[0]);
}

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (
            event.target !== container &&
            event.target !== last &&
            event.target !== first
        )
            return;

        document.addEventListener("keydown", trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
        document.removeEventListener("keydown", trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if (
            (event.target === container || event.target === first) &&
            event.shiftKey
        ) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener("focusout", trapFocusHandlers.focusout);
    document.addEventListener("focusin", trapFocusHandlers.focusin);

    elementToFocus?.focus();
}

function pauseAllMedia() {
    document.querySelectorAll(".js-youtube").forEach((video) => {
        video.contentWindow.postMessage(
            '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
            "*"
        );
    });
    document.querySelectorAll(".js-vimeo").forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', "*");
    });
    document.querySelectorAll("video").forEach((video) => {
        if (video.closest(".collage-video")) return;
        video.pause();
    });
    document
        .querySelectorAll("product-model")
        .forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener("focusin", trapFocusHandlers.focusin);
    document.removeEventListener("focusout", trapFocusHandlers.focusout);
    document.removeEventListener("keydown", trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

const serializeForm = (form) => {
    const obj = {};
    const formData = new FormData(form);
    for (const key of formData.keys()) {
        obj[key] = formData.get(key);
    }
    return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
    return {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: `application/${type}`,
        },
    };
}

function createFromTemplate(templateId) {
    return document
        .getElementById(templateId)
        .content.firstElementChild.cloneNode(true);
}

function publish(eventName, data) {
    if (subscribers[eventName]) {
        subscribers[eventName].forEach((callback) => {
            callback(data);
        });
    }
}
/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
    window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
    return function () {
        return fn.apply(scope, arguments);
    };
};

Shopify.setSelectorByValue = function (selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];
        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function (target, eventName, callback) {
    target.addEventListener
        ? target.addEventListener(eventName, callback, false)
        : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
    options = options || {};
    var method = options["method"] || "post";
    var params = options["parameters"] || {};

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for (var key in params) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
    country_domid,
    province_domid,
    options
) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(
        options["hideElement"] || province_domid
    );

    Shopify.addListener(
        this.countryEl,
        "change",
        Shopify.bind(this.countryHandler, this)
    );

    this.initCountry();
    this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
        var value = this.countryEl.getAttribute("data-default");
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },

    initProvince: function () {
        var value = this.provinceEl.getAttribute("data-default");
        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function (e) {
        var opt = this.countryEl.options[this.countryEl.selectedIndex];
        var raw = opt.getAttribute("data-provinces");
        var provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);
        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = "none";
        } else {
            for (var i = 0; i < provinces.length; i++) {
                var opt = document.createElement("option");
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }

            this.provinceContainer.style.display = "";
        }
    },

    clearOptions: function (selector) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },

    setOptions: function (selector, values) {
        for (var i = 0, count = values.length; i < values.length; i++) {
            var opt = document.createElement("option");
            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    },
};

class ModalDialog extends HTMLElement {
    constructor() {
        super();

        this.bodyOverflowAttribute = "data-modal-opened";
        this.querySelector('[id^="ModalClose-"]').addEventListener(
            "click",
            this.hide.bind(this)
        );
        this.addEventListener("click", (event) => {
            if (event.target.nodeName === "MODAL-DIALOG") this.hide();
        });
        this.addEventListener("keyup", () => {
            if (event.code?.toUpperCase() === "ESCAPE") this.hide();
        });
    }

    show(opener) {
        this.openedBy = opener;
        this.setAttribute("open", "");
        document.body.setAttribute(this.bodyOverflowAttribute, true);
        this.querySelector(".template-popup")?.loadContent();
        trapFocus(this, this.querySelector('[role="dialog"]'));
    }

    hide() {
        this.removeAttribute("open");
        document.body.removeAttribute(this.bodyOverflowAttribute);
        removeTrapFocus(this.openedBy);
        window.pauseAllMedia();
    }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
    constructor() {
        super();

        const button = this.querySelector("button");
        button?.addEventListener("click", () => {
            document
                .querySelector(this.getAttribute("data-modal"))
                ?.show(button);
        });
    }
}
customElements.define("modal-opener", ModalOpener);

(() => {
    let innerWidth = window.innerWidth;

    window.addEventListener(
        "resize",
        debounce(() => {
            if (innerWidth !== window.innerWidth) {
                innerWidth = window.innerWidth;
                publish(PUB_SUB_EVENTS.windowResizeX, undefined);
            }
        }, 200)
    );
})();

// --- SpecHavn Custom Global Cart Logic ---

window.submitShCollectionCartForm = function(e, form) {
    e.preventDefault();
    const btn = form.querySelector('button[type="submit"]');
    if (btn.classList.contains('adding')) return;
    
    const ogText = btn.innerHTML;
    btn.classList.add('adding');
    btn.style.opacity = '0.5';
    btn.style.pointerEvents = 'none';
    const span = btn.querySelector('span');
    if(span) span.innerText = 'Adding...';

    const formData = new FormData(form);
    const cartSidebar = document.querySelector('cart-sidebar');
    
    if (cartSidebar && cartSidebar.getSectionsToRender) {
       let sections = cartSidebar.getSectionsToRender().map(s => s.id);
       // Check if there are missing essential sections
       if(!sections.includes('cart-icon-bubble')) sections.push('cart-icon-bubble');
       formData.append("sections", sections.join(','));
       formData.append("sections_url", window.location.pathname);
    } else {
       formData.append("sections", "cart-sidebar,cart-icon-bubble");
       formData.append("sections_url", window.location.pathname);
    }

    fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(res => res.json())
    .then(jsonResponse => {
      if (jsonResponse.status && jsonResponse.description) {
         // This is a Shopify Error (like Max Quantity reached)
         btn.innerHTML = `<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg><span>Limit Reached</span>`;
         btn.style.color = '#ef4444';
         btn.style.borderColor = '#ef4444';
         btn.style.opacity = '1';
         btn.style.pointerEvents = 'none';
         
         setTimeout(() => {
            btn.innerHTML = ogText;
            btn.style.color = '';
            btn.style.borderColor = '';
            btn.style.pointerEvents = 'auto';
            btn.classList.remove('adding');
         }, 2500);
         return; // Do not open cart or proceed
      }

      // 1. Trigger visual 'Added!' animation on the button
      btn.classList.add('added-to-cart-success');
      const textSpan = btn.querySelector('span');
      if (textSpan) {
          textSpan.innerText = 'Added!';
      }
      
      setTimeout(() => {
         btn.innerHTML = ogText;
         btn.classList.remove('adding', 'added-to-cart-success');
         btn.style.display = 'none';
         const qtyWrapper = form.querySelector('.sh-inline-qty');
         if (qtyWrapper) {
            qtyWrapper.style.display = 'flex';
            const numSpan = qtyWrapper.querySelector('.sh-inline-qty-num');
            if(numSpan) {
                numSpan.innerText = jsonResponse.quantity || 1;
            }
         }
      }, 3000);

      // 2. Open the Cart Drawer
      if (cartSidebar && jsonResponse.sections) {
         if (cartSidebar.renderContents) cartSidebar.renderContents(jsonResponse);
         if (cartSidebar.open) cartSidebar.open();
         else {
            const bubble = document.getElementById('cart-icon-bubble');
            if (bubble) bubble.click();
         }
      } else {
         const bubble = document.getElementById('cart-icon-bubble');
         if (bubble) bubble.click();
      }
    })
    .catch(err => {
      console.error('Add to cart failed', err);
      btn.innerHTML = ogText;
      btn.style.opacity = '1';
      btn.style.pointerEvents = 'auto';
      btn.classList.remove('adding');
    });
};
  
window.updateShInlineQty = function(e, btnElement, change) {
  e.preventDefault();
  e.stopPropagation();
  
  const form = btnElement.closest('form');
  const idInput = form.querySelector('input[name="id"]');
  const numSpan = form.querySelector('.sh-inline-qty-num');
  
  let currentQty = parseInt(numSpan.innerText) || 1;
  let newQty = currentQty + change;
  if (newQty < 0) newQty = 0;
  
  numSpan.style.opacity = '0.5';
  btnElement.style.pointerEvents = 'none';
  
  const cartSidebar = document.querySelector('cart-sidebar');
  let sectionsQuery = '';
  if (cartSidebar && cartSidebar.getSectionsToRender) {
     let sections = cartSidebar.getSectionsToRender().map(s => s.id);
     if(!sections.includes('cart-icon-bubble')) sections.push('cart-icon-bubble');
     sectionsQuery = `?sections=${sections.join(',')}&sections_url=${window.location.pathname}`;
  } else {
     sectionsQuery = `?sections=cart-sidebar,cart-icon-bubble&sections_url=${window.location.pathname}`;
  }

  fetch((window.Shopify?.routes?.root || '/') + 'cart/change.js' + sectionsQuery, {
     method: 'POST',
     headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
     body: JSON.stringify({
       id: idInput.value,
       quantity: newQty
     })
  })
  .then(res => res.json())
  .then(jsonResponse => {
     numSpan.style.opacity = '1';
     btnElement.style.pointerEvents = 'auto';
     
     if (jsonResponse.status && jsonResponse.description) {
         console.error(jsonResponse.description);
         numSpan.innerText = currentQty;
         return;
     }

     if (newQty === 0) {
        form.querySelector('.sh-inline-qty').style.display = 'none';
        form.querySelector('.sh-card-btn').style.display = 'flex';
     } else {
        const updatedItem = (jsonResponse.items || []).find(item => item.id.toString() === idInput.value || item.variant_id.toString() === idInput.value);
        numSpan.innerText = updatedItem ? updatedItem.quantity : newQty;
     }

     document.dispatchEvent(new CustomEvent('cart:updated', { detail: jsonResponse }));
     
     if (cartSidebar && jsonResponse.sections) {
        if (cartSidebar.renderContents) cartSidebar.renderContents(jsonResponse);
     }
     
     const bubble = document.getElementById('cart-icon-bubble');
     if(bubble && jsonResponse.sections && jsonResponse.sections['cart-icon-bubble']) {
         bubble.innerHTML = jsonResponse.sections['cart-icon-bubble'];
     }
  })
  .catch(err => {
     console.error('Error changing qty', err);
     numSpan.style.opacity = '1';
     btnElement.style.pointerEvents = 'auto';
  });
};
